var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmaLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.667 15.333A3.333 3.333 0 1 0 12 18.667v-3.334m-3.333 0H12m-3.333 0a3.333 3.333 0 0 1 0-6.666M12 15.333V8.667m3.333 0a3.333 3.333 0 0 0 0-6.667H12m3.333 6.667H12m3.333 0a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666ZM12 2v6.667M12 2H8.667a3.333 3.333 0 0 0 0 6.667m3.333 0H8.667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLine);
export default __webpack_public_path__ + "static/media/figma_line.04133778b2f0eb1340cf0832a83b7d38.svg";
export { ForwardRef as ReactComponent };